function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * HOW TO USE
 *
 * Please ensure your style (your_style_here) is copied to 2 parts
 *   1. Prop for TouchableNativeFeedbackOpacity => TouchableOpacity (iOS) read highest component's style from here
 *   2. In highest level props.children => TouchableNativeFeedback (Android) read highest component's style from here
 *
 * eg.
 * <TouchableNativeFeedbackOpacity style={{...your_style_here}}>
 *   <View style={{}...your_style_here}>
 *     {components}
 *   </View>
 * </TouchableNativeFeedbackOpacity>
 *
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Platform, TouchableNativeFeedback, TouchableOpacity } from 'react-native';
import TouchableRipple from '../TouchableRipple';
const SUPPORTS_NATIVE_FEEDBACK = Platform.OS === 'android' && Platform.Version >= 21;
const TouchableNativeFeedbackOpacity = props => {
  if (Platform.OS === 'android') {
    let background = TouchableNativeFeedback.SelectableBackground();
    if (props.useRipple && SUPPORTS_NATIVE_FEEDBACK) {
      background = TouchableNativeFeedback.Ripple('#CACACA', true);
    }
    return /*#__PURE__*/React.createElement(TouchableNativeFeedback, _extends({
      delayPressIn: 1,
      background: background
    }, props), props.children);
  }
  if (Platform.OS === 'ios') {
    const {
      useRipple,
      ...rest
    } = props;
    return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      style: {
        flex: 1
      }
    }, rest), props.children);
  }
  const {
    useRipple,
    children,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(TouchableRipple, rest, children);
};
TouchableNativeFeedbackOpacity.displayName = "TouchableNativeFeedbackOpacity";
TouchableNativeFeedbackOpacity.propTypes = process.env.NODE_ENV !== "production" ? {
  useRipple: PropTypes.bool,
  children: PropTypes.node.isRequired
} : {};
TouchableNativeFeedbackOpacity.defaultProps = {
  useRipple: false
};
export default TouchableNativeFeedbackOpacity;